module.exports = __webpack_public_path__ + "static/media/Close.32d19c01.svg";